import React from 'react';
import { NumberFormatValues, SourceInfo } from 'react-number-format';
import NumberMaskedField, { NumberMaskedFieldProps } from '../NumberMaskedField';

export type PhoneFieldValues = {
  formattedValue: string;
  e164Value: string;
};

export type PhoneFieldChangeHandler = (value: string, values: PhoneFieldValues) => void;

export type PhoneFieldProps = Omit<NumberMaskedFieldProps, 'onChange'> & {
  onChange?: PhoneFieldChangeHandler;
  value?: string;
};

const defaultMaskedProps = {
  format: '###-###-####',
  disabled: false,
};

export const PhoneField = ({
  MaskedProps = {},
  name,
  value: valueProp = '',
  onChange: onChangeProp = () => undefined,
  InputProps,
  ...props
}: PhoneFieldProps): JSX.Element => {
  const trimmedInput = valueProp ? valueProp.replace(/^\+1/, '') : '';

  const { onValueChange, ...otherMaskedProps } = MaskedProps;

  //For future handling of international numbers, possible implementation of google-libphonenumbers might be the way to go
  //https://www.npmjs.com/package/google-libphonenumber
  const handleChange = (values: NumberFormatValues, sourceInfo: SourceInfo) => {
    //Only append +1 if there are values, otherwise the component will still output +1
    const e164Value = values.value.length > 0 ? '+1' + values.value : '';

    onValueChange?.(values, sourceInfo);
    onChangeProp?.(e164Value, { formattedValue: values.formattedValue, e164Value });
  };

  return (
    <NumberMaskedField
      fullWidth
      MaskedProps={{
        onValueChange: (values, e) => handleChange(values, e),
        ...defaultMaskedProps,
        ...otherMaskedProps,
      }}
      InputProps={{
        ...InputProps,
        name: name,
      }}
      value={trimmedInput}
      {...props}
    />
  );
};

export default PhoneField;
